import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";

import "../../../styles/components/map/filter/FilterType.scss";
import arrow from "../../../styles/images/arrow_black.svg";

class ConnectorType extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      collapsed: true,
    };

    this.handleOnClickAccordion = this.handleOnClickAccordion.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleOnClickAccordion(e) {
    this.safeSetState(prevState => ({ collapsed: !prevState.collapsed }));
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <Accordion id="connectorType">
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0" onClick={this.handleOnClickAccordion}>
            <Translate value="mapFilter_connectorType" />
            <img src={arrow} alt="" className={this.state.collapsed ? "arrow" : "arrow open"} />
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <div className="types-container">
                {Object.keys(this.props.plugs).map(k => (
                  <div key={k} className="type" onClick={() => this.props.onPlugClick(k)}>
                    <img
                      src={
                        this.props.plugs[k].picked
                          ? this.props.plugs[k].selected
                          : this.props.plugs[k].plug
                      }
                      alt=""
                    />
                    <p>{this.props.plugs[k].name}</p>
                  </div>
                ))}
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    );
  }
}

export default ConnectorType;
